import React from 'react'
import './Kafel.scss'

function Kafel(props) {
  
  return (
    <div className='kafel-div'>
        
            <img src={props.ico} alt='ikona dekoracyjna' className='deco-icon' />
            <h4 className='unbounded-font'>{props.title}</h4>
            <p className='inter-font'>{props.description}</p>
        

    </div>
  )
}

export default Kafel